<h2 mat-dialog-title>Vytvořit testovací data</h2>
<div class="selection">
  @if (enabled) {
    <p class="environment">Prostředí: <strong>{{ environmentName }}</strong> · {{ apiUrl }}</p>
    <mat-form-field appearance="outline">
      <mat-label>Typ testovacích dat</mat-label>
      <mat-select [value]="selected?.id" (selectionChange)="selectFixture($event.value)" [disabled]="loading || busy || hasResult">
        @for (definition of definitions; track definition.id) {
          <mat-option [value]="definition.id">{{ definition.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (!selected) {
      <p>Nejprve vyberte, jaká testovací data chcete vytvořit. Samotné otevření okna nic nevytváří.</p>
    } @else if (!hasResult) {
      <p>{{ selected.description }}</p>
    }
    @if (loading) {
      <p class="loading" role="status"><mat-spinner diameter="24"></mat-spinner>Načítání generátoru…</p>
    }
    @if (hasResult) {
      <p>Výsledky této sady jsou níže. Před vytvořením další sady si uložte manifest a otevřete nové okno fixtures.</p>
    }
    @if (error) {
      <p class="error" role="alert">{{ error }}</p>
      <button mat-stroked-button type="button" (click)="selectFixture(selected.id)">Načíst znovu</button>
    }
  } @else {
    <p role="alert">Fixtures jsou dostupné pouze na localhostu, DEV a UAT.</p>
  }
</div>
<ng-container #generatorHost></ng-container>
@if (!hasGenerator) {
  <mat-dialog-actions align="end"><button mat-button mat-dialog-close type="button">Zavřít</button></mat-dialog-actions>
}
